// extracted by mini-css-extract-plugin
export default {"container":"Drawer-modules__container__TjVBC","open":"Drawer-modules__open__YP3im","background":"Drawer-modules__background__m7mcu","drawer":"Drawer-modules__drawer__xFqeR"};